<template>
    <div class="tool-box">
        <div class="content">
            <el-breadcrumb class="bread-nav" separator="/">
                <el-breadcrumb-item>首页</el-breadcrumb-item>
                <el-breadcrumb-item>工具</el-breadcrumb-item>
            </el-breadcrumb>
            <div class="list-box">
                <ul>
                    <li>
                        <div @click="uploadFile" class="tool-item-box">
                            <div class="icon-box">
                                <img src="../../assets/upload.png" >
                            </div>
                            <div class="name-box">文件上传</div>
                        </div>
                    </li>
                    <li>
                        <div @click="importData" class="tool-item-box excel-data-upload">
                            <div class="icon-box">
                                <img src="../../assets/data.png" >
                            </div>
                            <div class="name-box">Excel数据入库</div>
                        </div>
                    </li>
                </ul>
            </div>
        </div>
    </div>
</template>
<script>
    import CONFIG from './../../config/index.js';
    export default {
        name: 'Tool',
        data() {
            return {

            };
        },
        methods: {
            uploadFile(){
                window.open(CONFIG.HOST + '/tool/uploadpage');
            },
            importData(){
                window.open(CONFIG.HOST + '/tool/uploadpage' + '?v=1.0.0');
            }
        }
    };
</script>
<style lang="less">
    .tool-box{
        ul,ol,li {
            list-style-type: none;
        }
        margin-left: 220px;
        .content{
            width: 98%;
            margin: 0 auto;
            .bread-nav{
                margin: 20px 0;
            }
            .list-box{
                ul{
                    li{
                        height: 100px;
                        float: left;
                        margin-right: 20px;
                        cursor: pointer;
                        
                        .tool-item-box{
                            height: 120%;
                            width: 120px;

                            border: 2px solid #97a8be;
                            border-radius: 10px;
                            text-align: center;
                            .icon-box{
                                margin-top: 10px;
                            }
                            .name-box{
                                color: #48576a;
                                font-weight: bolder;
                            }
                            img{
                                width: 90%;
                            }
                        }
                        .excel-data-upload{
                            img{
                                width: 60%;
                            }
                        }
                    }
                }
            }
        }
        
    }
</style>



// WEBPACK FOOTER //
// Index.vue?6794d68f